// SAVE AS: src/features/admin/planApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface MemberPlan {
  id: number;
  plan_name: string;
  plan_price: number | string;
  stripe_plan_id: string;
  description?: string;
  recurring: 1 | 2; // 1 = Monthly, 2 = Yearly
  status: 1 | 2;    // 1 = Active, 2 = Inactive
  created_at?: string;
  updated_at?: string;
}

export interface PlanFormData {
  plan_name: string;
  plan_price: number | string;
  stripe_plan_id: string;
  description?: string;
  recurring: 1 | 2;
  status: 1 | 2;
}

export const planApi = createApi({
  reducerPath: 'planApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT, // ✅ same as couponApi
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Plan'],
  endpoints: (build) => ({

    listPlans: build.query<
      { data: MemberPlan[]; error: boolean; message: string },
      void
    >({
      query: () => ({
        url: 'user/list-membership',
        method: 'POST',
        body: {},
      }),
      transformResponse: (
        response: Array<{ data: MemberPlan[]; error: boolean; message: string }>
      ) => response[0],
      providesTags: ['Plan'],
    }),

    createPlan: build.mutation<
      { error: boolean; message: string; data?: MemberPlan[] },
      PlanFormData
    >({
      query: (body) => ({
        url: 'user/add-membership',
        method: 'POST',
        body,
      }),
      transformResponse: (
        response: Array<{ error: boolean; message: string; data?: MemberPlan[] }>
      ) => response[0],
      invalidatesTags: ['Plan'],
    }),

    updatePlan: build.mutation<
      { error: boolean; message: string; data?: MemberPlan[] },
      { id: number } & Partial<PlanFormData>
    >({
      query: ({ id, ...body }) => ({
        url: 'user/update-membership',
        method: 'POST',
        body: { id, ...body },
      }),
      transformResponse: (
        response: Array<{ error: boolean; message: string; data?: MemberPlan[] }>
      ) => response[0],
      invalidatesTags: ['Plan'],
    }),

  }),
});

export const {
  useListPlansQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
} = planApi;